import React from 'react';
import {connect} from 'react-redux';
// Components
import Header from 'Components/common/Header';
import BasicButton from 'Components/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import ReceivePackageCard from 'Components/host/ReceivePackageCard';
import {Checkbox} from '@material-ui/core';
import SearchInput from 'Components/common/SearchInput';
import LoadingIcon from 'Components/icons/LoadingIcon';

// Actions
import {openNotification} from 'Actions/notification';
import {
    updateF1OrderReceiveSearchList,
    getF1ShipmentWaitReceive,
    getF1ShipmentWaitShipped,
    getF1ShipmentReceived,
    f1ReceivePackage,
} from 'Actions/host';
import {T} from 'Actions/translate';

class F1PackageReceive extends React.Component {
    state = {
        productsReceivingQuantity: [],
        receiveBtnsIsLoading: [],
        receiveAllBtnIsLoading: false,
        exitOpened: false,
        receiveExitOpened: false,
        f1OrderReceiveData: [],
        isAllReceive: false,
        productQuantity: [],
        currentItem: null,
        currentIndex: 0,
        checked: true,
        defaultCheck: null,
        checkAll: true,
        currentProductIds: [],
        allReceiveOrderArry: [],
        f1OrderReceiveList: [],
        orderNumber: '',
        f1WaitReceivedList: {},
        allF1WaitShippedList: {},
        f1WaitShippedList: {},
        f1ReceivedList: {},
        packageStatus: 'toBeReceived',
        f1PackageReceivePageLoad: true,
        cancelReceivePackageDialogOpened: false,
        receiveQuantity: 0,
    };

    componentWillMount() {
        this.props.updateF1OrderReceiveSearchList({
            queryKey: {$set: ''},
        });

        this.getPackageReceive();
    }
    onChange = (title, value) => {
        this.props.updateF1OrderReceiveSearchList({
            [title]: {$set: value},
        });
    };

    search = () => {
        this.setState({f1OrderReceiveList: []});
        if (this.props.queryKey.trim()) {
            let routerState = this.getRouterState();
            if (JSON.stringify(routerState) !== '{}') {
                if (routerState.orderStatus === 'toBeReceived') {
                    this.getPackageReceive();
                } else if (routerState.orderStatus === 'received') {
                    this.getPackageReceive();
                } else if (routerState.orderStatus === 'toBeShipped') {
                    this.getCurrentWaitShippedData(this.props.queryKey);
                }
            }
        } else {
            this.getPackageReceive();
        }
    };

    getCurrentWaitShippedData = (queryKey) => {
        let currentWaitReceiveList = JSON.parse(
            JSON.stringify(this.state.allF1WaitShippedList),
        );

        let currentQueryKey = queryKey.trim();
        if (
            currentWaitReceiveList.waitShipSkus &&
            currentWaitReceiveList.waitShipSkus.length > 0
        ) {
            let waitShipSkus = currentWaitReceiveList.waitShipSkus;
            let currentWaitShippedSkuArrys = [];
            waitShipSkus.map((waitShipItem, waitShipIndex) => {
                let currentItem = Object.assign({}, waitShipItem);
                let reg = eval('/' + currentQueryKey + '/ig');
                if (currentItem.sku && reg.test(currentItem.sku)) {
                    currentWaitShippedSkuArrys.push(currentItem);
                }
            });
            currentWaitReceiveList.waitShipSkus = currentWaitShippedSkuArrys;
        }
        this.setState({
            f1WaitShippedList: currentWaitReceiveList,
        });
    };

    getPackageReceive = () => {
        let routerState = this.getRouterState();
        if (JSON.stringify(routerState) !== '{}') {
            let orderId = routerState.id;
            if (
                routerState.orderStatus === 'toBeReceived' ||
                routerState.orderStatus === 'received'
            ) {
                if (routerState.orderStatus === 'toBeReceived') {
                    let params = {};
                    if (this.props.queryKey.trim()) {
                        params = {
                            id: orderId,
                            shipmentNumber: routerState.shipmentNumber,
                            searchVal: this.props.queryKey.trim(),
                        };
                    } else {
                        params = {
                            id: orderId,
                            shipmentNumber: routerState.shipmentNumber,
                        };
                    }
                    this.props
                        .getF1ShipmentWaitReceive(params)
                        .then((res) => {
                            if (res && res.status === 'success') {
                                let waitReceiveList = res.data;
                                JSON.stringify(waitReceiveList) !== '{}' &&
                                    waitReceiveList.products &&
                                    waitReceiveList.products.length > 0 &&
                                    res.data.products.map(
                                        (
                                            packageProductItem,
                                            packageProductIndex,
                                        ) => {
                                            packageProductItem.checked = true;
                                        },
                                    );
                                this.setState(
                                    {
                                        f1WaitReceivedList: waitReceiveList,
                                        packageStatus: routerState.orderStatus,
                                        f1PackageReceivePageLoad: false,
                                    },
                                    this.showOrderNumber(waitReceiveList),
                                );
                            }
                        })
                        .catch((res) => {
                            this.setState({
                                f1PackageReceivePageLoad: true,
                            });
                        });
                } else if (routerState.orderStatus === 'received') {
                    let receivedParams = {};
                    if (this.props.queryKey.trim()) {
                        receivedParams = {
                            shipmentId: routerState.id,
                            searchVal: this.props.queryKey.trim(),
                        };
                    } else {
                        receivedParams = {
                            shipmentId: routerState.id,
                        };
                    }
                    this.props
                        .getF1ShipmentReceived(receivedParams)
                        .then((res) => {
                            if (res && res.status === 'success') {
                                this.setState(
                                    {
                                        f1ReceivedList: res.data,
                                        packageStatus: routerState.orderStatus,
                                        f1PackageReceivePageLoad: false,
                                    },
                                    this.showOrderNumber(res.data),
                                );
                            }
                        })
                        .catch((res) => {
                            this.setState({
                                f1PackageReceivePageLoad: true,
                            });
                        });
                }
            } else if (routerState.orderStatus === 'toBeShipped') {
                this.props
                    .getF1ShipmentWaitShipped({id: orderId})
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.setState(
                                {
                                    f1WaitShippedList: res.data,
                                    allF1WaitShippedList: JSON.parse(
                                        JSON.stringify(res.data),
                                    ),
                                    packageStatus: routerState.orderStatus,
                                    f1PackageReceivePageLoad: false,
                                },
                                this.showOrderNumber(res.data),
                            );
                        }
                    })
                    .catch((res) => {
                        this.setState({
                            f1PackageReceivePageLoad: true,
                        });
                    });
            }
        }
    };

    getRouterState = () => {
        let routerState = '';
        if (this.props.history.location.state) {
            routerState = this.props.history.location.state;
        }
        return routerState;
    };

    goBack = () => {
        this.props.updateF1OrderReceiveSearchList({
            queryKey: {$set: ''},
        });
        this.props.history.goBack();
    };

    showOrderNumber = (orderList) => {
        let routerState = this.getRouterState();
        if (JSON.stringify(routerState) !== '{}') {
            let number = 0;
            if (routerState.orderStatus === 'toBeReceived') {
                number = orderList.number;
            } else if (routerState.orderStatus === 'received') {
                number = orderList.number;
            } else if (routerState.orderStatus === 'toBeShipped') {
                number = orderList.number;
            }
            this.setState({
                orderNumber: number,
            });
        }
    };

    receiveSingleHandleCheck = (index, event) => {
        let isCheckedFlag = event.target.checked;
        let currentWaitReceiveList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        currentWaitReceiveList.products.map(
            (f1WaitReceivedItem, f1WaitReceivedIndex) => {
                if (index === f1WaitReceivedIndex) {
                    f1WaitReceivedItem.checked = isCheckedFlag;
                }
            },
        );
        this.setState({
            f1WaitReceivedList: currentWaitReceiveList,
        });
    };

    allReceiveHandleCheck = (name) => (event) => {
        let allf1WaitReceivedList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        JSON.stringify(allf1WaitReceivedList) !== '{}' &&
            allf1WaitReceivedList.products.map((item, idx) => {
                item.checked = event.target.checked;
            });

        this.setState({
            checkAll: event.target.checked,
            f1WaitReceivedList: allf1WaitReceivedList,
        });
    };

    allReceivePackage = () => {
        this.setState({
            cancelReceivePackageDialogOpened: true,
        });
    };

    confirmReceivePackageHandle = () => {
        let allReceivedList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        let allProducts = [];
        JSON.stringify(allReceivedList) !== '{}' &&
            allReceivedList.products.map((item, idx) => {
                let currentItem = Object.assign({}, item);
                if (currentItem.checked) {
                    allProducts.push(currentItem);
                }
            });

        allReceivedList.products = allProducts;
        this.props
            .f1ReceivePackage(allReceivedList)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.props.openNotification(
                        T('notification_successful_receipt_of_goods'),
                        'success',
                    );
                    this.getPackageReceive();

                    let orderId = '';
                    let routerState = this.getRouterState();
                    if (typeof routerState.id !== 'undefined') {
                        orderId = parseInt(routerState.id);
                    }
                    this.props.updateF1OrderReceiveSearchList({
                        queryKey: {$set: ''},
                    });
                    this.props.history.push(
                        `/F1OrderReceiveManagement/${orderId}`,
                    );
                    this.setState({
                        cancelReceivePackageDialogOpened: false,
                    });
                }
            })
            .catch((res) => {
                this.props.openNotification(
                    T('notification_goods_failed'),
                    'danger',
                );
                this.setState({
                    cancelReceivePackageDialogOpened: false,
                });
            });
    };

    dialogDidClose = (dialog) =>
        this.state[dialog] && this.setState({[dialog]: false});

    getReceivePackageQuantity = () => {
        let allReceivedList = JSON.parse(
            JSON.stringify(this.state.f1WaitReceivedList),
        );
        let checkedQuantity = 0;
        if (JSON.stringify(allReceivedList) !== '{}') {
            if (
                allReceivedList.products &&
                allReceivedList.products.length > 0
            ) {
                allReceivedList.products.map((receiveItem, receiveIndex) => {
                    if (receiveItem.checked) {
                        ++checkedQuantity;
                    }
                });
            }
        }
        return checkedQuantity;
    };

    render() {
        const {F1OrderDetails, f1ShipmentWaitshipped, queryKey} = this.props;
        const {
            checkAll,
            orderNumber,
            f1WaitReceivedList,
            f1WaitShippedList,
            f1ReceivedList,
            packageStatus,
            f1PackageReceivePageLoad,
            cancelReceivePackageDialogOpened,
        } = this.state;

        let checkedQuantity = this.getReceivePackageQuantity();
        if (F1OrderDetails.orderProducts) {
            for (let n = 0; n < F1OrderDetails.orderProducts.length; n++) {
                F1OrderDetails.orderProducts[n]['checked'] = true;
            }
        }

        return (
            <div className="F1-order-receive-container">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <p className="header-order-number">
                        {T('host_fone_order_number')}{' '}
                        <span className="numer">{orderNumber}</span>
                    </p>
                    <div className="header-search-input">
                        <SearchInput
                            title="queryKey"
                            value={queryKey}
                            placeholder={T('enter_sku')}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                </Header>
                {f1PackageReceivePageLoad ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <div>
                        <ul className="f1-shippment-wait-shipped">
                            {JSON.stringify(f1WaitShippedList) !== '{}' &&
                            f1WaitShippedList.waitShipSkus.length > 0
                                ? f1WaitShippedList.waitShipSkus.map(
                                      (waitShipItem, waitShipIndex) => (
                                          <li key={waitShipIndex}>
                                              <div className="first-row">
                                                  <div className="wait-shipped-sku">
                                                      {T('host_product_sku')}
                                                      <span className="sku-value">
                                                          {waitShipItem.sku}
                                                      </span>
                                                  </div>
                                                  <span className="f1-wait-shipped-quantity">
                                                      {T('host_wait_quantity')}
                                                      <span className="sku-quantity">
                                                          {
                                                              waitShipItem.quantity
                                                          }
                                                      </span>
                                                  </span>
                                              </div>
                                              {waitShipItem.esd && (
                                                  <div className="second-row">
                                                      <div className="wait-shipped-esd">
                                                          {T(
                                                              'fone_order_pre_deliver_time',
                                                          )}
                                                          <span className="esd-value">
                                                              {waitShipItem.esd}
                                                          </span>
                                                      </div>
                                                  </div>
                                              )}
                                          </li>
                                      ),
                                  )
                                : null}
                        </ul>
                        {packageStatus === 'toBeReceived' ||
                        packageStatus === 'received' ? (
                            <ReceivePackageCard
                                f1PackageReceive={
                                    packageStatus === 'toBeReceived'
                                        ? f1WaitReceivedList
                                        : f1ReceivedList
                                }
                                packageStatus={packageStatus}
                                receiveSingleHandleCheck={
                                    this.receiveSingleHandleCheck
                                }></ReceivePackageCard>
                        ) : null}
                    </div>
                )}

                {this.props.history.location.state &&
                this.props.history.location.state.orderStatus ===
                    'toBeReceived' ? (
                    <div className="footer-wrap">
                        <div className="footer clearfix container-max-width is-fixed">
                            <div className="all-selected" xs={3}>
                                <Checkbox
                                    checked={checkAll}
                                    onChange={this.allReceiveHandleCheck(
                                        'checkAll',
                                    )}
                                />
                                <span className="all-selected-title">
                                    {T('f1_order_receive_select_all')}
                                </span>
                            </div>
                            <BasicButton
                                className="all-receive-btn pull-right"
                                type="primary"
                                disabled={checkedQuantity > 0 ? false : true}
                                onClickOfSingleTap={this.allReceivePackage}>
                                {T('shippment_take_goods')}
                            </BasicButton>
                        </div>
                    </div>
                ) : null}

                <Dialog
                    opened={cancelReceivePackageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('cancelReceivePackageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="receive-package-dialog">
                        <h5 className="receive-package-dialog-title text-center">
                            {T('order_confirm_receive')}
                        </h5>
                        <p className="receive-package-dialog-desc text-center">
                            {T('host_confirm_receive')}
                        </p>
                        <div className="receive-package-btn-container">
                            <BasicButton
                                type="primary"
                                className="receive-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmReceivePackageHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'cancelReceivePackageDialogOpened',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        F1OrderDetails: host.F1OrderDetails,
        skuReplenishmentDetail: host.skuReplenishmentDetail,
        queryKey: host.f1OrderReceiveSearchfields.queryKey,
        updateF1OrderList: host.updateF1OrderList,
        f1ShipmentWaitReceive: host.f1ShipmentWaitReceive,
        f1ShipmentWaitshipped: host.f1ShipmentWaitshipped,
        f1ShipmentReceived: host.f1ShipmentReceived,
    };
};

const mapDispatchToProps = {
    openNotification,
    updateF1OrderReceiveSearchList,
    getF1ShipmentWaitReceive,
    getF1ShipmentWaitShipped,
    getF1ShipmentReceived,
    f1ReceivePackage,
};

export default connect(mapStateToProps, mapDispatchToProps)(F1PackageReceive);
